import {
    CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS,
    CREATE_ADVANCED_DISBURSEMENT,
    EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_CREATE_ADVANCED_DISBURSEMENT,
    FAILED_TO_EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
    FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
    GET_ADVANCE_DISBURSEMENT_BY_ID,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS,
    GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES, GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED,
    GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS,
    GET_ADVANCE_DISBURSEMENTS_STATUSES,
    GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    GET_ALL_ADVANCED_DISBURSEMENTS,
    GET_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
    GET_APPLICATION_AD_UPDATE_STATUS,
    GET_APPLICATION_AD_UPDATE_STATUS_FAIL,
    GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS,
    RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
    RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
    RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
    RECEIVE_CREATE_ADVANCED_DISBURSEMENT,
    RECEIVE_EDIT_ADVANCE_DISBURSEMENT
} from "./index";
import {actionCreator} from "../helpers/functions";

export const getAdvanceDisbursementsStatementMessages = actionCreator(GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES);
export const getAdvanceDisbursementsStatementMessagesSuccess = actionCreator(GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS);
export const getAdvanceDisbursementsStatementMessagesFailed = actionCreator(GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED);

export const getAdvanceDisbursementsDueForPayment = actionCreator(GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT);
export const getAdvanceDisbursementsDueForPaymentSuccess = actionCreator(GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS);
export const getAdvanceDisbursementsDueForPaymentFailed = actionCreator(GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED);

//action that checks if update is needed before making an ad
export function getApplicationAdUpdateStatus(payload) {
    return {
        type: GET_APPLICATION_AD_UPDATE_STATUS,
        payload: payload
    }
}

//action that receives failed response form checking if update is needed before making an ad
export function getApplicationAdUpdateStatusSuccess(payload) {
    return {
        type: GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS,
        payload: payload
    }
}

//action that receives error response from getting the application status
export function getApplicationAdUpdateStatusFail(payload) {
    return {
        type: GET_APPLICATION_AD_UPDATE_STATUS_FAIL,
        payload: payload
    }
}

//action that requests the ad statuses
export function getAdvanceDisbursementsStatuses() {
    return {
        type: GET_ADVANCE_DISBURSEMENTS_STATUSES,
    }
}

//action that receives the advance disbursementsStatuses
export function receivedAdvancedDisbursementsStatuses(payload) {
    return {
        type: RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
        payload: payload
    }
}

//action that failed to receive advance disbursement statuses
export function failedToReceiveAdvanceDisbursementsStatuses(payload) {
    return {
        type: FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
        payload: payload
    }
}

export function getAdvanceDisbursementsRejectionReasons() {
    return {
        type: GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    }
}

//action that receives the advance disbursementsStatuses
export function receivedAdvanceDisbursementsRejectionReasons(payload) {
    return {
        type: RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
        payload: payload
    }
}

//action that failed to receive advance disbursement statuses
export function failedToReceiveAdvanceDisbursementsRejectionReasons(payload) {
    return {
        type: FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
        payload: payload
    }
}

//action that requests edit ad
export function editAdvancedDisbursement(payload) {
    return {
        type: EDIT_ADVANCE_DISBURSEMENT,
        payload: payload
    }
}

//action that receives edit advance disbursement response
export function receiveEditAdvanceDisbursement(payload) {
    return {
        type: RECEIVE_EDIT_ADVANCE_DISBURSEMENT,
        payload: payload
    }
}

//action that failed to edit ad response
export function failedToEditAdvanceDisbursement(payload) {
    return {
        type: FAILED_TO_EDIT_ADVANCE_DISBURSEMENT,
        payload: payload
    }
}

//action that requests get ad by id
export function getAdvanceDisbursementById(payload) {
    return {
        type: GET_ADVANCE_DISBURSEMENT_BY_ID,
        payload: payload
    }
}

//action that receives the advanced disbursement by id
export function receiveAdvanceDisbursementById(payload) {
    return {
        type: RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
        payload: payload
    }
}

//action that receives error while getting the advance disbursement by id
export function failedToReceiveAdvanceDisbursementById(payload) {
    return {
        type: FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
        payload: payload
    }
}

//action that requests post new advanced disbursement
export function createAdvancedDisbursement(advancedDisbursement) {
    return {
        type: CREATE_ADVANCED_DISBURSEMENT,
        payload: advancedDisbursement
    }
}

//action that receives create ad response
export function receiveCreateAdvancedDisbursement(response) {
    return {
        type: RECEIVE_CREATE_ADVANCED_DISBURSEMENT,
        payload: response
    }
}

//action that receives failed response while creating ad
export function failedToCreateAdvancedDisbursement(response) {
    return {
        type: FAILED_TO_CREATE_ADVANCED_DISBURSEMENT,
        payload: response
    }
}

//action that get advanced disbursements of a policy
export function getAdvancedDisbursementsOfAPolicy(payload) {
    return {
        type: GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
        payload: payload
    }
}

//action that receives advanced disbursements of a policy
export function receiveAdvancedDisbursementsOfAPolicy(payload) {
    return {
        type: RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
        payload: payload
    }
}

//action that receives failed response from requesting the advancedDisbursementsOfAPolicy
export function failedToReceiveAdvancedDisbursementsOfAPolicy(payload) {
    return {
        type: FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
        payload: payload
    }
}

//action that request the all advanced disbursements
export function getAllAdvancedDisbursements(payload) {
    return {
        type: GET_ALL_ADVANCED_DISBURSEMENTS,
        payload: payload
    }
}

//action that receives all advanced disbursements
export function receiveAllAdvancedDisbursements(payload) {
    return {
        type: RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
        payload: payload
    }
}

//action that receives failed response from getting all advanced disbursements
export function failedToReceiveALlAdvancedDisbursements(payload) {
    return {
        type: FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
        payload: payload
    }
}

//action that requests all advanced disbursements suggestions
export function getAllAdvancedDisbursementsSuggestions(payload) {
    return {
        type: GET_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
        payload: payload
    }
}

//action that
export function receiveAllAdvancedDisbursementsSuggestions(payload) {
    return {
        type: RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
        payload: payload
    }
}

//action that receives error getting all advanced disbursements suggestions
export function failedToReceiveAdvancedDisbursementsSuggestions(payload) {
    return {
        type: FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_SUGGESTIONS,
        payload: payload
    }
}

//action that changes the advance disbursements store settings
export function changeAdvanceDisbursementsStoreSettings(payload) {
    return {
        type: CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS,
        payload: payload
    }
}